export default __webpack_public_path__ + "static/media/qna-cancel-src.c75fcaf1.svg";